// Syntax-highlighted code, rendered at build time with highlight.js (the Webflow site ran
// highlight.js in the browser). Markup matches what hljs produced there:
// <code class="language-python hljs" data-highlighted="yes">...</code>.

import hljs from 'highlight.js/lib/core';
import python from 'highlight.js/lib/languages/python';
import type { HTMLAttributes } from 'react';

function highlight(code: string, language: string): string {
  // Registered on first use rather than at import time, so bundling this module into pages
  // without code samples doesn't pull highlight.js in with it.
  if (!hljs.getLanguage('python')) hljs.registerLanguage('python', python);
  return hljs.getLanguage(language) ? hljs.highlight(code, { language }).value : hljs.highlightAuto(code).value;
}

/** A <code> element (inside a <pre>) highlighted in place, like hljs.highlightAll(). */
export function HighlightedCode({ code, className, ...props }: HTMLAttributes<HTMLElement> & { code: string }) {
  const language = /language-(\w+)/.exec(className ?? '')?.[1] ?? 'python';
  return (
    <code
      {...props}
      className={`${className ?? ''} hljs`.trim()}
      data-highlighted="yes"
      dangerouslySetInnerHTML={{ __html: highlight(code, language) }}
    />
  );
}

/**
 * A Webflow "code source" block: code typed into a rich-text div, shown as a highlighted
 * <pre><code class="language-python"> block (this replaces the site's custom formatting script).
 */
export function CodeSource({ code, language = 'python' }: { code: string; language?: string }) {
  return (
    <pre>
      <HighlightedCode className={`language-${language}`} code={code} />
    </pre>
  );
}
